import {useHistory} from 'react-router-dom';
import {Button} from '../../../components/Button';

type ShowUserIdProps = {
    userId: string[]
}

const ShowUserId = (props: ShowUserIdProps) => {
    const {userId} = props;
    const history = useHistory();

    return (
        <div className="flex flex-col items-center justify-center mt-4">
            {0 < userId.length ?
                <>
                    <span className="text-14 font-normal" style={{color: '#6D7684'}}>
                      {'고객님의 아이디입니다! 지금 다시 로그인해보세요.'}
                    </span>
                    <div
                        className={
                            'flex flex-row items-center justify-center bg-gray-50 mt-10 w-full'
                        }
                        style={{height: 97}}>
                        {userId.map((id, index) => (
                            <span className="text-16 font-bold" key={index}>{id}<br/></span>
                        ))}
                    </div>
                    <Button
                        onClick={() => history.push('/find/password')}
                        type="button"
                        text="비밀번호 찾기"
                        className="border text-black border-gray-500 w-full mt-10"
                    />
                    <Button
                        onClick={() => history.push('/login')}
                        type="button"
                        text="로그인 →"
                        className="filled-gray-900 w-full mt-2"
                    />
                </>
                :
                <>
                    <span className="text-14 font-normal" style={{color: '#6D7684'}}>
                      {'해당 전화번호로 가입하신 내역이 없습니다.'}
                    </span>
                    <Button
                        onClick={() => history.push('/signup')}
                        type="button"
                        text="회원가입 →"
                        className="filled-gray-900 w-full mt-10"
                    />
                </>
            }

        </div>
    );
};

export default ShowUserId;
